import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    body: string;
    handleClose: {
        (confirm: boolean): void
    }
}

export default (props: ConfirmationDialogProps) => {
    return (
        <Dialog
            PaperProps={{
                sx: {
                    position: 'absolute' as 'absolute',
                    top: '30%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    pb: 1
                }
            }}
            open={props.open}
            onClick={() => props.handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.body}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleClose(false)}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={() => props.handleClose(true)} autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}